export const ANIMATION_TIME = 200;
